"use client";

import { useState } from "react";

import { Pagination } from "@/types/page.types";

export type UsePaginationReturn = Pagination;

export type UsePaginationProps = {
  initialPageNumber?: number;
  initialPageSize?: number;
};

const usePagination = (props?: UsePaginationProps): UsePaginationReturn => {
  const { initialPageNumber = 1, initialPageSize = 50 } = props || {};
  const [pageNumber, setPageNumber] = useState(initialPageNumber);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const next = () => setPageNumber((prevPage) => prevPage + 1);

  const previous = () => setPageNumber((prevPage) => Math.max(prevPage - 1, 1));

  const extend = (newPageSize: number) => {
    setPageSize(newPageSize);
    // Ajusta o pageNumber para 1 caso o novo pageSize possa resultar em uma página atual sem itens.
    setPageNumber((currentPage) => {
      const totalItems = currentPage * pageSize; // Estimativa do número total de itens até a página atual
      if (totalItems <= newPageSize) {
        return 1; // Se o total de itens não exceder o novo pageSize, volta para a primeira página
      }
      return currentPage; // Mantém a página atual se o ajuste não for necessário
    });
  };

  const changePage = (newPageNumber: number) => {
    setPageNumber(newPageNumber + 1);
  };

  return {
    next,
    previous,
    extend,
    pageSize,
    pageNumber,
    changePage,
  };
};

export default usePagination;
